import React, {useContext} from "react";
import {GlobalContext} from "../../../../../../App.tsx";
import {MessageBottomContainerContext, MessageContext} from "../../../Message.tsx";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {handleChangeStateIndex} from "../../../../../../Utils/messageObject/messageObjectUtils.ts";

interface ToggleStateProps {}

const ToggleState: React.FC<ToggleStateProps> = ({ }) => {
    const { messagesRef, currentMessageRef, messagesSequenceRef, setMessages } = useContext(GlobalContext);
    const { isPreview } = useContext(MessageContext);
    const { group } = useContext(MessageBottomContainerContext);
    const userObj = useAppStore((state: any) => state.userObj);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { conversationId, canSubmit } = dynamicStateObj;
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { isIncognito } = settingsObj;

    const changeStateIndex = (forward: boolean) => {
        handleChangeStateIndex(userObj.user, isIncognito, conversationId, group.index, forward, messagesSequenceRef, currentMessageRef, setMessages, messagesRef);
    }

    return (
        <div className="flex justify-end">
            <button
                className={`text-sm text-gray-500 focus:outline-none ${
                    canSubmit && group.parentSelectedChild > 0
                        ? "hover:text-gray-700 cursor-pointer"
                        : "opacity-50 cursor-default"
                } ${isPreview ? "pointer-events-none" : " "}`}
                onClick={() => canSubmit && group.parentSelectedChild > 0 && changeStateIndex(false)}
            >
                &lt;
            </button>
            <span className="text-sm text-gray-500 mx-1">
                                    {group.parentSelectedChild + 1}/{group.totalChildren}
                                </span>
            <button
                className={`text-sm text-gray-500 focus:outline-none ${
                    canSubmit && group.parentSelectedChild + 1 < group.totalChildren
                        ? "hover:text-gray-700 cursor-pointer"
                        : "opacity-50 cursor-default"
                } ${isPreview ? "pointer-events-none" : " "}`}
                onClick={() => canSubmit && group.parentSelectedChild + 1 < group.totalChildren && changeStateIndex(true)}
            >
                &gt;
            </button>
        </div>
    )
}

export default ToggleState;
